<template>
    <div>
    <masternav/>
    <!--  -->
      <b-nav class="navlinks ">
        <b-nav-item router-link :to="{ name: 'Home'}">
          <span class="navtext ">{{$t('location.loc1')}} </span>
        </b-nav-item>
          <span class="mt-2 text-secondary">/</span>
        <b-nav-item disabled>
            <span class="navtext2">{{$t('location.loc2')}}</span>
        </b-nav-item>
      </b-nav>
      <br>
    <!--  -->
    <div class="container-fluid mt-3 mb-3">
    <b-row>
      <b-col md="9">
        <div class="">
          <h1 class="titlequestion">{{$t('location.loc3')}}</h1>
        
        </div>
        <!-- <div 
        class="mt-3">
        Selected: 
        <strong>{{ selectedLocation }}</strong>
        </div> -->

        <b-modal 
        id="modal-lg" 
        size="xl" 
        hide-footer
        >
        <reservestep1and2/>
        </b-modal>
      </b-col>
      <b-col md="3">
        <div class="text-center m-2">
          <router-link :to="{ name: 'Home'}" style="text-decoration:none">
          <b-button 
          block 
          squared 
          class="buttonreserve"
          >{{$t('location.loc4')}}
          </b-button>
          </router-link>
        </div>
      </b-col>
    </b-row>
    </div><br>
    <!-- locations -->
    <div class="container-fluid">
      <b-row>
        <!-- locations list -->
        <b-col>
          <b-row 
          style="border: solid 1px #c3c3c3"
          :key="item.id"
          v-for="(item, index) in locations.data"
          v-show="item.enterprise==1"
          
          >
          <!-- <p>{{item.enterprise}}</p> -->
            <!-- <pre>{{item}}</pre> -->
            <b-col cols="1" class="countlocations">
              <!-- <span>{{index+1}}</span> --> 
            </b-col>
            <b-col cols="10" v-show="item.region_id == menulocationfilter"> <!--se ocultan las demás sucursales -->
              <div class="mt-3 ml-2">
                <b-row>
                  <b-col md="8">
                    <h3 class="titlelocationlist ">{{item.nombre_web}}</h3>
                    <span class="textlocationlist">{{item.comuna}}, {{item.direccion}}</span><br>
                    <span class="textlocationlist">{{item.ciudad}}</span>
                  </b-col>
                  <b-col md="4">
                     <b-button 
                     block 
                     squared 
                     class="button text-uppercase" 
                     v-b-modal.modal-lg
                     @click="selecionSucursalSalida(item.id)"
                     >{{$t('buttons_label.select')}}
                     </b-button>
                     
                  </b-col>
                </b-row>
                <div class="mb-1 mt-2">
                   <!-- para que sea dinamico hay que agregar {{sucursal}}+menu en toggle -->
                   <p class="locationdetails" v-b-toggle="'collapse'+item.id">
                   <svg width="2em" height="2em" viewBox="1 8 16 16" class="bi bi-chevron-down mt-3" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                     <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                   </svg>
                   {{$t('location.loc5')}}
                   </p>
                   <!-- collapse -->
                   <b-collapse 
                   v-bind:id="'collapse'+item.id"
                   class=""
                   style=""
                   >
                     <b-card class="rounded-0" style="border:none">
                      <b-row>
                        <b-col md>
                          <p class="titlelocationlist">{{$t('location.loc6')}}</p>
                          <p class="textlocationlist">
                            <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-telephone" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" d="M3.925 1.745a.636.636 0 0 0-.951-.059l-.97.97c-.453.453-.62 1.095-.421 1.658A16.47 16.47 0 0 0 5.49 10.51a16.471 16.471 0 0 0 6.196 3.907c.563.198 1.205.032 1.658-.421l.97-.97a.636.636 0 0 0-.06-.951l-2.162-1.682a.636.636 0 0 0-.544-.115l-2.052.513a1.636 1.636 0 0 1-1.554-.43L5.64 8.058a1.636 1.636 0 0 1-.43-1.554l.513-2.052a.636.636 0 0 0-.115-.544L3.925 1.745zM2.267.98a1.636 1.636 0 0 1 2.448.153l1.681 2.162c.309.396.418.913.296 1.4l-.513 2.053a.636.636 0 0 0 .167.604L8.65 9.654a.636.636 0 0 0 .604.167l2.052-.513a1.636 1.636 0 0 1 1.401.296l2.162 1.681c.777.604.849 1.753.153 2.448l-.97.97c-.693.693-1.73.998-2.697.658a17.47 17.47 0 0 1-6.571-4.144A17.47 17.47 0 0 1 .639 4.646c-.34-.967-.035-2.004.658-2.698l.97-.969z"/>
                            </svg> 
                            {{item.telefono1}}
                          </p>
                          <router-link :to="{ name: 'Help'}">
                          <p class="textlocationlist">
                            <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-question-circle mr-2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                              <path d="M5.25 6.033h1.32c0-.781.458-1.384 1.36-1.384.685 0 1.313.343 1.313 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.007.463h1.307v-.355c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.326 0-2.786.647-2.754 2.533zm1.562 5.516c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                            </svg>
                             {{$t('location.loc7')}}
                          </p>
                          </router-link>
                        </b-col>
                        <b-col md>
                          <br class="d-none d-sm-none d-md-block">
                          <p class="textlocationlist mt-3"> {{$t('location.loc8')}}    {{item.horario_sem}}</p>
                          <p class="textlocationlist">      {{$t('location.loc9')}}    {{item.horario_sabado}}</p>
                          <p class="textlocationlist">      {{$t('location.loc10')}}   {{item.horario_domingo}}</p>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md>
                            <img 
                            class="mt-3"
                            :src="item.extras.url_imagen" 
                            width="100%" 
                            height="200" 
                            alt="">
                        </b-col>
                        <b-col md>
                            <iframe 
                            class="mt-3"
                            :src="item.extras.url_mapa_enterprise" 
                            frameborder="0"
                            width="100%" 
                            height="200" 
                            ></iframe>
                        </b-col>
                      </b-row>
                      
                     </b-card>
                   </b-collapse>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <!-- maps -->
        <b-col class=" border-top border-bottom border-secondary d-none d-sm-none d-md-block">
          <section class="mapmain">
          <iframe src="https://www.google.com/maps/d/embed?mid=1f3ps72AuscjHL5CSoS_OfwyEQlfmQI-R" 
          style="z-index: 3;
                 height: 100%;
                 width: 100%;
                 padding: 0px;
                 "
          width="655" 
          height="480">
          </iframe>
          </section>
        </b-col>
      </b-row>
      <!-- <pre>{{locations}}</pre> -->
    </div>
    <br>
    <!--  -->
    <contactcomp/>
    <br>
    <mainfooter/>
    </div>
</template>
<script>
import masternav          from '@/components/masternav.vue'
import maincontent        from '@/components/maincontent.vue'
import mainfooter         from '@/components/mainfooter.vue'
import contactcomp        from '@/components/contactcomp.vue'
import rents              from '@/components/rents.vue'
import reservestep1and2   from '@/components/reservestep1and2.vue'
import {mapState, mapActions, mapMutations} from 'vuex'
export default {
    name: 'Locations',
    metaInfo: {
      title: "Enterprise Panama - Sucursales | Alquiler de Autos",
      meta: [
        {
          vmid: 'A',
          name: 'description',
          content: 'Arriendo de vehiculos en Panamá. Empresa dedicada al arriendo de vehículos en Panamá, entre otros: automoviles, camionetas, van.',
        },
        {
          vmid: 'B',
          name: 'keywords',
          content: 'Enteprise panama, Enterprise rent a car, enterprise renta car, ALAMO, ENTERPRISE PANAMA, ALAMO PANAMA'
        }
      ]
    },
    components:{
        masternav,
        mainfooter,
        maincontent,
        rents,
        reservestep1and2,
        contactcomp
    },
    data() {
      return {
        places: ['Aeropuerto Internacional de Tocumen, Tocumen','Calle 50, Obarrio',  'Calle Eusebio A. Morales, El Cangrejo', 'Hotel Westin, Costa del Este',  'Aeropuerto Marcos A. Gelabert, Albrook', 'Albrook Village, Albrook',  'Aeropuerto Enrique Malek, Chiriquí', 'Mareas Mall, Playa Blanca, Coclé'],
        selectedLocation: ''
      }
    },
    mounted(){
      this.getLocationsList();
       if(this.$router.currentRoute.path === '/locations')
        {
          this.resetValues()
          //console.clear()
      }
    },
    computed:{
      ...mapState(['locations']),
      ...mapState(['menulocationfilter'])
    },
    methods: {
      ...mapMutations('reserva', ['selecionSucursalSalida', 'resetValues']),
      ...mapActions(['getLocationsList']),
      selectloc(){
        this.selectedLocation = this.item.nombre
      }
    }
  }
</script>
<style  scoped>
@font-face {
    font-family: 'DIN 2014-ExraBold';
    src: url('../assets/fonts/DIN2014-ExtraBold.ttf');

}
@font-face {
    font-family: 'DIN 2014-Regular';
    src: url('../assets/fonts/DIN2014-Regular.ttf');
}
.mapmain {
  width:100%;
  height:100%;
  overflow:hidden;
}
iframe {
	margin-top:-50px;
}
.dinregular{
  font-family: 'DIN 2014-Regular';
}
.dinbold{
  font-family: 'DIN 2014-ExraBold';
}
.supportside{
  background-color: rgb(235, 235, 235);
  
}
.listgroup{
  border-top: none;
  border-left: none;
  border-right: none;
}
.supporticons{
    height: 50px;
    width: 50px;
    margin-bottom: 15px;
    margin-top: 30px;
}
.titlesection{
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
   
   color: #333333;
   font-weight: 600;
   margin-bottom: 15px;
}
.titlesupp{
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 18px;
   color: #169a5a;
   font-weight: 600;
   margin-bottom: 15px;
}
.textsupp{
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 18px;
   color: #169a5a;
}
.titlelocationlist{
   color: #181918; 
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 18px;
   font-weight: 600;
}
.textlocationlist{
  color: #656565; 
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
  font-size: 16px;
  font-weight: 300;
  padding: 0px;
}
.wrapper {
    min-height: 100%;
    height: auto !important;
    margin: 0 auto -30px;
    padding: 0 0 30px 0px;   /* new padding */
}
.collapsing {
  transition: none !important;
}
.titlequestion{
   font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
   font-size: 32px;
   margin-top: 15px;
   margin-left: 30px;
   font-weight: 800;
   color: #181918;
}
.countlocations{
   background: #169A5A;
   color: #ffffff; 
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 28px;
   font-weight: 300;
}
.locationdetails{
  color: #169A5A;
  font-family: 'DIN 2014-ExtraBold', Arial, sans-serif;
  font-weight: 600;
  font-size: 14px;
  text-decoration: none;
}
.locationdetails:focus {
  outline: 2px solid #a4ceff !important;
}
.questions{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    margin-left: 32px;
    line-height: 40px;
    color: #169a5a;
    font-size: 17px;
    font-weight: 500;
    text-decoration: none;
    margin: 0px;
    padding: 0px;
}
.questions:hover {
  color: #006639 !important;
}
.questions:focus {
  outline: 2px solid #a4ceff !important;
}
.navlinks{
    border-bottom: solid 0.05px rgb(185, 185, 185);
    
}
.navtext{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #169a5a !important;
    font-size: 14px;
    font-weight: 300;
}
.navtext2{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #686e6b !important;
    font-size: 14px;
    font-weight: 300;
}
.button{
  font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
  Color: #FFFFFF;
  Size: 14px;
  letter-spacing: 0.9px;
  font-weight: 600;
  Text-align: center;
  Text-transform: uppercase;
  Background: #169A5A;
  Height: 33px;
  border: none;
}
.button:hover{
  Background:#006639;
}
.buttonreserve{
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
  Color: #169A5A;
  font-size: 18px;
  font-weight: 600;
  Text-align: center;
  text-decoration: none !important;
  Background: #ffffff;
  Height: 64px;
  border: solid 2px #169A5A;
}
.buttonreserve:hover{
  Background:#169A5A;
  border: solid 2px #169A5A;
  text-decoration: none !important;
  Color: #ffffff;
}
.buttonfindoffice{
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
  Color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  Text-align: center;
  Background: #169A5A;
  Height: 64px;
  border: solid 2px #169A5A;
}
.buttonfindoffice:hover{
  Background:#006639;
  border: solid 2px #006639;
}
.noline{
  text-decoration: none;
}
.titlefindoffice{
  color: #333333; 
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
  font-size: 30px;
  font-weight: 400;
  height: 35px;
  margin-top: 21px;
}
.inputfindoffice{
  border: solid 2px #bebebe;
   Height: 64px;
}
.navfontfindoffice{
color: #169A5A; 
font-family: 'DIN 2014-ExraBold', sans-serif;
font-size: 18px;
font-weight: 700;
height: 26px;
line-height: 16.3333px;
}
.navfontfindoffice:hover{
  color: #333333; 
}
.textmenufindoffice{
  font-family: 'DIN 2014-Regular', sans-serif;
  color: #169A5A;
  text-decoration: none;
  
  font-size: 16px;
}
.textmenufindoffice:hover{
  color: #333333; 
}
</style>